import React from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import * as S from './styled'
import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'
import { withI18n } from '../../hocs'
import { DateInput, InputField, CheckButton } from '../../atoms'
import ActionDialog from '../action-dialog'

const ModalCreateReport = ({ i18n, reportFields, onSubmit }) => {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    reset()
    setOpen(false)
  }

  const [values, setValues] = React.useState({})
  /*const handleChangeValue = e => {
    if (e.target.checked) {
      setValues({ ...values, [e.target.name]: e.target.checked })
    } else {
      setValues(_.omit(values, e.target.name))
    }
    if (selectAll) {
      setSelectAll(false);
    }
  }*/

  const [title, setTitle] = React.useState('')
  const handleChangeTitle = title => setTitle(title)

  const [dateFrom, setDateFrom] = React.useState(null)
  const handleChangeDateFrom = date => setDateFrom(date)

  const [dateTo, setDateTo] = React.useState(null)
  const handleChangeDateTo = date => setDateTo(date)

  const handleSubmit = e => {
    e && e.preventDefault()

    const data = {
      title: title,
      date_from: dateFrom ? moment(dateFrom).format('YYYY-MM-DD HH:mm:ss') : null,
      date_to: dateTo ? moment(dateTo).format('YYYY-MM-DD HH:mm:ss') : null,
      fields: JSON.stringify(_.keys(values))
    }

    // Si onSubmit devuelve la petición, el modal se cierra cuando ha ido bien; en error sigue abierto
    return Promise.resolve(onSubmit(_.pickBy(data, _.identity))).then(() => handleClose())
  }

  const [selectAll, setSelectAll] = React.useState(false);
  //const [checkedCount, setCheckedCount] = React.useState(0);

  /*React.useEffect(() => {
    if (reportFields) {
      setCheckedCount(reportFields.length);
    }
  }, [reportFields]);*/

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAll(checked);

    if (checked) {
      //setCheckedCount(reportFields.length);

      let newValues = {};
      reportFields.forEach(field => {
        newValues[field.remote_name] = true;
      });
      setValues(newValues);
    } else {
      //setCheckedCount(0);
      setValues({});
    }
  };

  const handleChangeCheck = (event) => {

    setValues({ ...values, [event.target.name]: event.target.checked });

    /*if(event.target.checked){
      setCheckedCount(prevCount => {
        const newCount = prevCount + 1;
        if (newCount === reportFields.length) {
          setSelectAll(true);
        }
        return newCount;
      });
    } else {
      setCheckedCount(prevCount => {
        if (prevCount - 1 === 0){
          setSelectAll(false);
        }
        return prevCount - 1;
      });
    }*/
  };

  const reset = () => {
    setValues({})
    setTitle('')
    setDateFrom(null)
    setDateTo(null)
  }

  const hasFields = !_.isEmpty(reportFields)
  const isSubmitReady = !_.isEmpty(title) && !_.isNull(dateFrom) && !_.isNull(dateTo)
  return (
    <div>
      {/* Sin campos disponibles el informe no tendría qué exportar: el botón queda deshabilitado */}
      <Tooltip title={hasFields ? '' : i18n.modalCreateReport.noFields} arrow>
        <span>
          <Button variant="contained" color="default" onClick={handleOpen} className="planning-btn" disabled={!hasFields}>
            {i18n.modalCreateReport.createReport}
          </Button>
        </span>
      </Tooltip>
      <ActionDialog
        open={open}
        title={i18n.modalCreateReport.createReport}
        onClose={handleClose}
        onConfirm={handleSubmit}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={i18n.modalCreateReport.createReport}
        confirmDisabled={!isSubmitReady}
        disableBackdropClose
      >
        <S.Body>
          <div>
            <S.Label>{i18n.modalCreateReport.name}*</S.Label>
            <InputField
              name="title"
              placeholder={i18n.modalCreateReport.reportName}
              handleOnChange={handleChangeTitle}
              value={title}
            />
          </div>
          <div>
            <S.Label>{i18n.modalCreateReport.date}*</S.Label>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <DateInput
                  placeholder={i18n.modalCreateReport.fromDate}
                  name="date_from"
                  value={dateFrom}
                  onChange={handleChangeDateFrom}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DateInput
                  placeholder={i18n.modalCreateReport.toDate}
                  name="date_to"
                  value={dateTo}
                  onChange={handleChangeDateTo}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <CheckButton
              title={i18n.modalCreateReport.selectAll}
              strong
              checked={selectAll}
              onChange={(e) => {
                handleSelectAll(e);
              }}
              color="primary"
            />
            {/* Cada campo del informe se muestra como casilla con su nombre, en dos columnas */}
            <Grid container>
              {_.map(reportFields, ({ name, remote_name }) => (
                <Grid item xs={12} sm={6} key={`mcr_${remote_name}`}>
                  <CheckButton
                    name={remote_name}
                    title={name}
                    checked={_.has(values, remote_name) ? _.get(values, remote_name) : (selectAll)}
                    onChange={handleChangeCheck}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </S.Body>
      </ActionDialog>
    </div>
  )
}

ModalCreateReport.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  reportFields: PropTypes.array,
  onSubmit: PropTypes.func.isRequired
}

const enharce = compose(withI18n)

export default enharce(ModalCreateReport)
